import dayjs from 'dayjs';
import api from '~/api';
import { GetRevenueShareExportResponse } from '../dtos/revenueShareExport.dto';
import { RevenueShareStatusResponse } from '../dtos/revenueShareResponse';
import { RevenueShareStatus } from '../models/revenueShare.model';

const statusMap: Record<RevenueShareStatus, RevenueShareStatusResponse> = {
  Open: 'open',
  Paid: 'paid',
  Submitted: 'in_progress',
};

export const getRevenueShareExportFilename = async (
  params: { period: string; status: RevenueShareStatus },
  partnerId: string
): Promise<{ filename: string }> => {
  const date = dayjs(params.period);
  const year = date.year();
  const month = date.month() + 1;

  const { data } = await api.post<GetRevenueShareExportResponse>(
    `/v1/revenue_share/partner/${partnerId}/export`,
    {
      month,
      year,
      status: statusMap[params.status],
    }
  );

  return {
    filename: data.filename,
  };
};
